import { render } from "./TermsDPASchedule1.vue?vue&type=template&id=5cd57889"
import script from "./TermsDPASchedule1.vue?vue&type=script&lang=js"
export * from "./TermsDPASchedule1.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__